/**
 * Maximum length of a message sent to the team through `POST /api/utils/signup/deliver-note`.
 * Mirrors `SIGNUP_MESSAGE_MAX_LENGTH` in `app/signup/deliver_note_validator.py`; the forms cap
 * their textareas with it so an overlong note is stopped in the browser instead of by a 400.
 */
export const SIGNUP_MESSAGE_MAX_LENGTH = 2000;

/** Fixed prefix the role-selection help form prepends, so its textarea gets the remaining budget. */
export const ROLE_HELP_MESSAGE_PREFIX = "HELP ME DECIDE: ";
